import escape from "lodash/escape";
import { WaypointSave } from "utils/parsers/waypointParser";
import { decodePolyline } from "utils/polyline";
import { wrap } from "./encodeHTML";

export const encodeWaypointsToGPX = (
  waypoints: (WaypointSave & { ele?: number })[]
) => {
  const result: string[] = [];
  waypoints.forEach((waypoint) => {
    const point = decodePolyline(waypoint.point);
    if (!point || !point[0]) throw new Error("Error encoding waypoints to GPX");

    const [latStr, lngStr] = point[0];

    result.push(`  <wpt lat="${latStr}" lon="${lngStr}">`);

    // A missing elevation is parsed from the API as 0, so 0 is treated as unknown and left out.
    // <ele> must be the first element in <wpt> (GPX 1.1 schema).
    if (Number.isFinite(waypoint.ele) && waypoint.ele !== 0)
      result.push(`    <ele>${waypoint.ele}</ele>`);

    // The elements must be in this order, as defined by the GPX 1.1 schema (wptType)
    if (waypoint.name) result.push(`    <name>${wrap(waypoint.name)}</name>`);
    if (waypoint.cmt) result.push(`    <cmt>${wrap(waypoint.cmt)}</cmt>`);
    if (waypoint.desc) result.push(`    <desc>${wrap(waypoint.desc)}</desc>`);
    if (waypoint.src) result.push(`    <src>${wrap(waypoint.src)}</src>`);

    if (waypoint.links) {
      const links = waypoint.links.split(",");
      links.forEach((link) => {
        const escapedLink = escape(link);
        result.push(`    <link href="${escapedLink}"></link>`);
      });
    }

    if (waypoint.icon) result.push(`    <sym>${wrap(waypoint.icon)}</sym>`);
    if (waypoint.type) result.push(`    <type>${wrap(waypoint.type)}</type>`);

    result.push("  </wpt>");
  });

  return result.join("\n");
};
